import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../Include/Header";
import Sidebar from "../../Include/Sidebar";
import Footer from "../../Include/Footer";
import Loader from "../../Include/Loader";
import { Pagination, Search } from "../../Table";
import DropDown from "../../../../Components/DropDown";
import axios from "axios";
import { V_URL } from "../../../../BaseUrl";

const ProStockPlatList = () => {
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setlimit] = useState(10);
  const [isLoading, setIsLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const [stockPlatData, setStockPlatData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const fetchData = useCallback(
    async (isRefresh = false) => {
      if (isRefresh) {
        setIsRefreshing(true);
      } else {
        setIsLoading(true);
      }

      try {
        const res = await axios.get(`${V_URL}/prosafe/get-plate-stock`);
        const data = res?.data?.data || [];
        setStockPlatData(data);

        if (search) {
          const filtered = data.filter((stock) =>
            stock.item_name?.toLowerCase()?.includes(search?.toLowerCase())
          );
          setFilteredData(filtered);
          setTotalItems(filtered.length);
        } else {
          setFilteredData(data);
          setTotalItems(data.length);
        }
      } catch (err) {
        console.log("Error fetching data:", err);
        setStockPlatData([]);
        setFilteredData([]);
        setTotalItems(0);
      } finally {
        setIsLoading(false);
        setIsRefreshing(false);
      }
    },
    [search]
  );

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!isLoading) {
      if (search) {
        const filtered = stockPlatData.filter((stock) =>
          stock.item_name?.toLowerCase()?.includes(search?.toLowerCase())
        );
        setFilteredData(filtered);
        setTotalItems(filtered.length);
      } else {
        setFilteredData(stockPlatData);
        setTotalItems(stockPlatData.length);
      }
      setCurrentPage(1);
    }
  }, [search, stockPlatData, isLoading]);

  const paginatedData = useMemo(() => {
    if (!filteredData.length) return [];

    const startIndex = (currentPage - 1) * limit;
    const endIndex = startIndex + limit;

    return filteredData.slice(startIndex, endIndex);
  }, [filteredData, currentPage, limit]);

  const handleRefresh = () => {
    setSearch("");
    fetchData(true);
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleLimitChange = (val) => {
    setlimit(val);
    setCurrentPage(1);
  };

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/main-store/user/dashboard">Dashboard </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right"></i>
                  </li>
                  <li className="breadcrumb-item active">Stock Plat List</li>
                </ul>
              </div>
            </div>
          </div>

          {!isLoading ? (
            <>
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-table show-entire">
                    <div className="card-body">
                      <div className="page-table-header mb-2">
                        <div className="row align-items-center">
                          <div className="col">
                            <div className="doctor-table-blk">
                              <h3>Stock Plat List</h3>
                              <div className="doctor-search-blk">
                                <div className="top-nav-search table-search-blk">
                                  <form onSubmit={(e) => e.preventDefault()}>
                                    <Search
                                      onSearch={handleSearch}
                                      value={search}
                                    />
                                    <button
                                      type="button"
                                      className="btn"
                                      onClick={() => handleSearch(search)}
                                    >
                                      <img
                                        src="/assets/img/icons/search-normal.svg"
                                        alt="firm-searchBox"
                                      />
                                    </button>
                                  </form>
                                </div>
                                <div className="add-group">
                                  <button
                                    type="button"
                                    onClick={handleRefresh}
                                    className="btn btn-primary doctor-refresh ms-2"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Refresh"
                                    disabled={isRefreshing}
                                  >
                                    {isRefreshing ? (
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                    ) : (
                                      <img
                                        src="/assets/img/icons/re-fresh.svg"
                                        alt="refresh"
                                      />
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                            <DropDown
                              limit={limit}
                              onLimitChange={handleLimitChange}
                            />
                          </div>
                        </div>
                      </div>

                      {isRefreshing ? (
                        <div className="text-center py-4">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">
                              Refreshing...
                            </span>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="table-responsive">
                            <table className="table border-0 custom-table comman-table  mb-0">
                              <thead>
                                <tr>
                                  <th>Sr.</th>
                                  <th>Item Name</th>
                                  <th>Plat No</th>
                                  <th>In Quantity</th>
                                  <th>Out Quantity</th>
                                  <th>Balance Qantity</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {paginatedData?.map((elem, i) => {
                                  const serialNumber =
                                    (currentPage - 1) * limit + i + 1;
                                  return (
                                    <tr
                                      key={`${elem?.item_id || "item"}-${
                                        elem?.plate_no || i
                                      }`}
                                    >
                                      <td>{serialNumber}</td>
                                      <td>{elem?.item_name || "-"}</td>
                                      <td>{elem?.plate_no || "-"}</td>
                                      <td>{elem?.in_qty || 0}</td>
                                      <td>{elem?.out_qty || 0}</td>
                                      <td>{elem?.balance_qty || 0}</td>
                                      <td>
                                        <span className={`status-badge`}>
                                          {elem.status === "PENDING" ? (
                                            <span className="custom-badge status-orange">
                                              Pending
                                            </span>
                                          ) : (
                                            <span className="custom-badge status-pink">
                                              Used
                                            </span>
                                          )}
                                        </span>
                                      </td>
                                    </tr>
                                  );
                                })}
                                {paginatedData?.length === 0 ? (
                                  <tr>
                                    <td colSpan="7">
                                      <div className="no-table-data text-center py-4">
                                        {search
                                          ? "No matching records found"
                                          : "No data available"}
                                      </div>
                                    </td>
                                  </tr>
                                ) : null}
                              </tbody>
                            </table>
                          </div>

                          {filteredData.length > 0 && (
                            <div className="row align-center mt-3 mb-2">
                              <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                <div
                                  className="dataTables_info"
                                  id="DataTables_Table_0_info"
                                  role="status"
                                  aria-live="polite"
                                >
                                  Showing{" "}
                                  {Math.min(
                                    limit,
                                    filteredData.length -
                                      (currentPage - 1) * limit
                                  )}{" "}
                                  of {totalItems} entries
                                </div>
                              </div>
                              <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                <div
                                  className="dataTables_paginate paging_simple_numbers"
                                  id="DataTables_Table_0_paginate"
                                >
                                  <Pagination
                                    total={totalItems}
                                    itemsPerPage={limit}
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <Loader />
            </>
          )}
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ProStockPlatList;
